import { useQuery } from "@tanstack/react-query";
import { Link, useNavigate } from "react-router-dom";
import { useSession } from "../lib/auth.ts";
import { fmtDurationMs, api, testResultLabel, testResultPillClass, testTypeLabel } from "../lib/api.ts";
import { ChartIcon, EmptyState } from "../components/EmptyState.tsx";

export function DashboardPage() {
  const { data: session } = useSession();
  const orgId = session?.session.activeOrganizationId;
  const nav = useNavigate();

  const devices = useQuery({
    queryKey: ["devices", orgId],
    queryFn: () => api.listDevices(orgId!),
    enabled: !!orgId,
  });

  const tests = useQuery({
    queryKey: ["tests", orgId, 5],
    queryFn: () => api.listTests(orgId!, 5),
    enabled: !!orgId,
  });

  return (
    <>
      <h1>Dashboard</h1>

      <div className="stat-grid">
        <div className="card">
          <h3>Devices</h3>
          <p className="stat-number">{devices.data?.devices.length ?? "—"}</p>
          <Link to="/devices">View all</Link>
        </div>
        <div className="card">
          <h3>Recent tests</h3>
          <p className="stat-number">{tests.data?.tests.length ?? "—"}</p>
          <Link to="/tests">View all</Link>
        </div>
      </div>

      <h3>Latest tests</h3>
      {tests.isLoading && <p className="muted">Loading…</p>}
      {tests.error && <p className="err">Couldn't load tests — {(tests.error as Error).message}</p>}
      {tests.data && tests.data.tests.length === 0 && (
        <EmptyState
          icon={<ChartIcon />}
          title="No tests yet"
          message="Pair a device on its Cloud screen to start syncing test results."
          action={<Link to="/devices">Go to devices</Link>}
        />
      )}
      {tests.data && tests.data.tests.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>When</th>
              <th>Type</th>
              <th>Result</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            {tests.data.tests.map((t) => (
              <tr key={t.id} onClick={() => nav(`/tests/${t.id}`)}>
                <td>{new Date(t.startedAt).toLocaleString()}</td>
                <td>{testTypeLabel(t.testType)}</td>
                <td>
                  <span className={testResultPillClass(t.testResult)}>
                    {testResultLabel(t.testResult)}
                  </span>
                </td>
                <td>{fmtDurationMs(t.durationMs)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
